import { render } from "./payout.vue?vue&type=template&id=1f9646b0&scoped=true&ts=true"
import script from "./payout.vue?vue&type=script&lang=ts"
export * from "./payout.vue?vue&type=script&lang=ts"

import "./payout.vue?vue&type=style&index=0&id=1f9646b0&lang=less&scoped=true"
import "./payout.vue?vue&type=style&index=1&id=1f9646b0&lang=less"

import exportComponent from "/data/gitlab/pay.klicklpay.com/KlicklPaymentPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9646b0"]])

export default __exports__